function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.63096 3.95924C0.696113 4.14621 0.0231934 4.96704 0.0231934 5.92041L0.0231934 17.8412C0.0231934 19.1033 1.17784 20.0499 2.41543 19.8024L18.4154 16.6024C19.3503 16.4154 20.0232 15.5946 20.0232 14.6412V2.72041C20.0232 1.45831 18.8685 0.511728 17.631 0.759245L1.63096 3.95924ZM18.5232 2.00205L2.02319 5.28062L2.02319 18.2806L18.5232 14.189V2.00205Z",
  fill: "#1C33C8"
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 0.0231934,
  y: 5.28052,
  width: 22,
  height: 16,
  rx: 2,
  fill: "#1C33C8"
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  x: 1.52319,
  y: 6.78052,
  width: 19,
  height: 13,
  fill: "white"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.0232 13.2805C13.0232 11.0714 14.8141 9.28052 17.0232 9.28052H23.0232C23.5755 9.28052 24.0232 9.72823 24.0232 10.2805V16.2805C24.0232 16.8328 23.5755 17.2805 23.0232 17.2805H17.0232C14.8141 17.2805 13.0232 15.4897 13.0232 13.2805Z",
  fill: "#1C33C8"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.5232 13.2805C14.5232 11.8998 15.6425 10.7805 17.0232 10.7805H22.5232V15.7805H17.0232C15.6425 15.7805 14.5232 14.6612 14.5232 13.2805Z",
  fill: "white"
});

var _ref7 =
/*#__PURE__*/
React.createElement("rect", {
  x: 16.2732,
  y: 12.5305,
  width: 1.5,
  height: 1.5,
  fill: "#1C33C8"
});

var SvgCash = function SvgCash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Cash.4749cd06.svg";
export { ForwardRef as ReactComponent };